import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, RocketIcon, MailIcon, GitBranchIcon, RepeatIcon, ClapperboardIcon, SparklesIcon, PackageCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
const features = [{
  icon: RocketIcon,
  text: 'Sistema completo de escalado de ads'
}, {
  icon: MailIcon,
  text: 'Email marketing y automatizaciones'
}, {
  icon: GitBranchIcon,
  text: 'Funnels avanzados de conversión'
}, {
  icon: RepeatIcon,
  text: 'Estrategias de retención y upsell'
}, {
  icon: ClapperboardIcon,
  text: 'Masterclass de creativos que convierten'
}, {
  icon: SparklesIcon,
  text: 'Masterclass en IA'
}];
export function Upsell() {
  return <section className="py-12 md:py-20 bg-dark-900 border-t border-white/5 relative overflow-hidden" data-id="element-307">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-308" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-309">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto" data-id="element-310">
          <div className="text-center mb-6 md:mb-8" data-id="element-311">
            <h2 className="text-gray-400 font-display text-xs md:text-xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-312">
              ¿Listo para el siguiente paso?
            </h2>
          </div>

          {/* Level progression visual */}
          <div className="flex items-stretch gap-2 md:gap-4 mb-6 md:mb-8" data-id="element-313">
            <div className="flex-1 bg-dark-800/40 rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/10 flex flex-col items-center text-center opacity-60" data-id="element-314">
              <div className="text-gold-500/70 font-display text-[10px] md:text-xs tracking-widest uppercase mb-1" data-id="element-315">
                Estás acá
              </div>
              <div className="text-3xl md:text-5xl font-display text-white uppercase" data-id="element-316">
                N1
              </div>
              <div className="text-[10px] md:text-sm text-gray-500 mt-1 leading-tight" data-id="element-317">
                Negocio funcionando
              </div>
            </div>

            <div className="flex items-center" data-id="element-318">
              <motion.div animate={{
              x: [0, 5, 0]
            }} transition={{
              duration: 1.5,
              repeat: Infinity
            }} data-id="element-319">
                <ArrowRightIcon className="text-gold-500 w-5 h-5 md:w-8 md:h-8" data-id="element-320" />
              </motion.div>
            </div>

            <div className="flex-1 bg-gradient-to-br from-gold-500/20 to-dark-800 rounded-xl md:rounded-2xl p-3 md:p-6 border-2 border-gold-500/60 flex flex-col items-center text-center shadow-[0_0_30px_rgba(212,175,55,0.2)] relative" data-id="element-321">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold-500 text-black font-display px-2 py-0.5 rounded-full text-[8px] md:text-[10px] tracking-widest uppercase whitespace-nowrap" data-id="element-322">
                Upgrade
              </div>
              <div className="text-gold-500 font-display text-[10px] md:text-xs tracking-widest uppercase mb-1" data-id="element-323">
                Próximo nivel
              </div>
              <div className="text-3xl md:text-5xl font-display text-gold-400 uppercase" data-id="element-324">
                N2
              </div>
              <div className="text-[10px] md:text-sm text-gray-300 mt-1 leading-tight" data-id="element-325">
                Escalado completo
              </div>
            </div>
          </div>

          <div className="text-center mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-326">
            <p className="text-2xl md:text-4xl font-display text-white uppercase tracking-wide mb-2 md:mb-3 leading-tight" data-id="element-327">
              Wealth Engine <span className="text-gold-500" data-id="element-328">— Nivel 2</span>
            </p>
            <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-329">
              El upgrade natural para escalar tu negocio: ads, email, comunidad
              y soporte directo.
            </p>
          </div>

          {/* 6 features grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-330">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <motion.div key={i} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.04
            }} whileHover={{
              y: -3,
              borderColor: 'rgba(212,175,55,0.5)'
            }} className="bg-dark-800/60 rounded-lg md:rounded-xl p-2.5 md:p-4 border border-white/10 flex flex-col items-center text-center transition-colors" data-id="element-331">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-gold-500/10 rounded-md md:rounded-lg flex items-center justify-center border border-gold-500/20 mb-1.5 md:mb-2" data-id="element-332">
                    <Icon className="text-gold-500 w-4 h-4 md:w-5 md:h-5" data-id="element-333" />
                  </div>
                  <span className="text-[10px] md:text-xs text-gray-200 font-medium leading-tight" data-id="element-334">
                    {feature.text}
                  </span>
                </motion.div>;
          })}
          </div>

          {/* Full-width "Nivel 1 included" strip — final row of the table */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-gradient-to-r from-gold-500/10 via-gold-500/20 to-gold-500/10 rounded-lg md:rounded-xl border border-gold-500/40 px-4 md:px-6 py-2.5 md:py-3 flex items-center justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-335">
            <PackageCheckIcon className="text-gold-500 w-4 h-4 md:w-5 md:h-5 shrink-0" data-id="element-336" />
            <span className="text-gold-300 text-[11px] md:text-sm font-bold uppercase tracking-widest text-center" data-id="element-337">
              + Todo el contenido del Nivel 1 incluido
            </span>
          </motion.div>

          <div className="text-center" data-id="element-338">
            <div className="inline-flex items-center gap-2 px-5 md:px-8 py-3 md:py-4 rounded-sm border-2 border-dashed border-gold-500/40 bg-dark-800/40 text-gold-500/80 font-display text-sm md:text-base uppercase tracking-wider cursor-not-allowed" data-id="element-339">
              <motion.span animate={{
              opacity: [0.4, 1, 0.4]
            }} transition={{
              duration: 1.8,
              repeat: Infinity
            }} className="w-2 h-2 rounded-full bg-gold-500" data-id="element-340" />
              Work in Progress
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}